import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ContractorService } from 'src/app/Service/Contractor/Contractor.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-ContractorCustomer',
  templateUrl: './ContractorCustomer.component.html',
  styleUrls: ['./ContractorCustomer.component.scss']
})
export class ContractorCustomerComponent implements OnInit {
  EditRecord:Number
  Contract_Title:String=""

  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Contractor_Service:ContractorService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService,
    private Customer_Service: CustomerService,
    private route: ActivatedRoute
  ) { }


  DataList_Contractor:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    this.Nav_Service.CheckValidPage(1118).subscribe(
      data=>{

        this.Contractor_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.Contract_Title=data.title
            this.ReadData_Contractor()
    
          }
        )
        
        
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

    
  }

  ReadData_Contractor(){
    this.Procssing=true
    this.Contractor_Service.GetCustomer(this.EditRecord).subscribe(
      data=>{
        this.DataList_Contractor=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Contractor_Service.DeleteCustomer(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_Contractor()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  
  //#region  مشتری
  ProcssingCustomer: boolean = false
  modalRef_Customer: any;
  DataList_Customer: Array<Customer_List_Interface> = []
  Search_CodeName_Customer_Table:string=''

  ReadData_Customer_KeySearch_Timer: any
  ReadData_Customer_KeySearch() {

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Customer()
    }.bind(this), 1000);

  }

  ReadData_Customer() {

    if (!this.Search_CodeName_Customer_Table) {
      this.DataList_Customer = []
    }
    else {

      this.ProcssingCustomer = true
      this.Customer_Service.GetSearchCalibration(this.Search_CodeName_Customer_Table).subscribe(
        data => {
          this.DataList_Customer = data
          this.ProcssingCustomer = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  Data_Seleted_Customer_Type: number = 0
  openModal_Customer(template: TemplateRef<any>, type_Customer) {
    this.Data_Seleted_Customer_Type = type_Customer
    this.modalRef_Customer = this.modalService.show(template);
  }


  Set_Selected_Customer_Record(item) {

    this.modalRef_Customer.hide()
    this.Procssing=true
    this.Contractor_Service.AddCustomer(Number(this.EditRecord),item.id).subscribe(
      data=>{
        this.Procssing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("مشتری برای این پیمانکار انتخاب شده است")
        }
        else{
          this.ReadData_Contractor()
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )


  }




  //#endregion


}
